/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import { timeCounterAction } from '@orientaction/api-actions';
import { useAlert, useMe, useResponseUser, useTest } from '@orientaction/hooks';
import { userService } from '@orientaction/services';
import { getFromLS } from '@orientaction/utils';
import classNames from 'classnames';
import parseHtml from 'html-react-parser';
import { find, groupBy, map, sumBy } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { publicIconPath, publicLogoPath } from '../../../../../utils/constants';
import { apiServiceNative } from '../../../../../utils/fetchNative';
import RedesignThemeProvider from '../../../RedesignThemeProvider';
import { MediaVideoPlayer, MediaVideoPlayerRef } from '../../../shared';
import RedesignImage from '../../../shared/components/RedesignImage';
import InlineSignup from '../../../shared/InlineSignup';
import ResumeTestModal from '../components/ResumeTestModal';
import { useMinorTestPassStyles } from './index.styles';

const qs = require('qs');

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const formatElapsed = (seconds: number) => {
  const safeSeconds = Math.max(0, seconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const remainingSeconds = safeSeconds % 60;

  return [hours, minutes, remainingSeconds].map(value => String(value).padStart(2, '0')).join(':');
};

const QuestionCountdown = ({
  seconds,
  onEnd,
  className,
}: {
  seconds: number;
  onEnd: () => void;
  className?: string;
}) => {
  const duration = Math.max(0, Number(seconds) || 0);
  const [remaining, setRemaining] = useState(duration);
  const hasEnded = useRef(false);
  const onEndRef = useRef(onEnd);

  onEndRef.current = onEnd;

  useEffect(() => {
    if (duration <= 0) {
      setRemaining(0);
      if (!hasEnded.current) {
        hasEnded.current = true;
        onEndRef.current();
      }
      return undefined;
    }

    hasEnded.current = false;
    const endTime = Date.now() + duration * 1000;
    setRemaining(duration);

    const interval = window.setInterval(() => {
      const nextRemaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setRemaining(nextRemaining);

      if (nextRemaining <= 0) {
        window.clearInterval(interval);
        if (!hasEnded.current) {
          hasEnded.current = true;
          onEndRef.current();
        }
      }
    }, 200);

    return () => window.clearInterval(interval);
  }, [duration]);

  return <span className={className}>{formatElapsed(remaining)}</span>;
};

const parseStoredUser = () => {
  try {
    return JSON.parse(getFromLS('userInfos') || '{}');
  } catch {
    return {};
  }
};

const MinorTestPass = () => {
  const classes = useMinorTestPassStyles();
  const history = useHistory();
  const { id: testId, title }: any = useParams();
  const dispatch = useDispatch();
  const alert = useAlert();
  const { me } = useMe();
  const { getTest, test, setProgress, getResponsesPopulate, loadPage } = useTest();
  const { postResponseUsers, getMyResponseUserForTest, saveResponseUserProgress } =
    useResponseUser();

  const user = useMemo(parseStoredUser, []);
  const token = localStorage.getItem('userToken') ? getFromLS('userToken') : '';
  const isConnected = Boolean(user?.id);
  const progressKey = `test_progress_${testId}`;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [valueArray, setValueArray] = useState<any[]>([]);
  const [dataToPost, setDataToPost] = useState<any>({ responses: [] });
  const [loading, setLoading] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [protectedTag, setProtectedTag] = useState<any>();
  const [showSignup, setShowSignup] = useState(false);
  const [showEmailCapture, setShowEmailCapture] = useState(false);
  const [captureEmail, setCaptureEmail] = useState('');
  const [emailCaptured, setEmailCaptured] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [savedProgress, setSavedProgress] = useState<any>(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  const progressReady = useRef(false);
  const startRef = useRef<number>(Date.now());
  const draftSaveTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const videoRefs = useRef<{ [key: number]: MediaVideoPlayerRef | null }>({});
  const topRef = useRef<HTMLDivElement>(null);

  const questions = test?.attributes?.questions?.data || [];
  const totalQuestions = questions.length;
  const currentQuestion = questions[currentIndex];
  const currentResponses = currentQuestion?.attributes?.responses?.data || [];
  const currentValue = valueArray[currentIndex];
  const progressPercent = totalQuestions
    ? Math.floor(((currentIndex + 1) * 100) / totalQuestions)
    : 0;
  const nextText = currentIndex + 1 === totalQuestions ? 'Voir mes résultats' : 'Question suivante';

  useEffect(() => {
    startRef.current = Date.now();
    const interval = window.setInterval(() => {
      setElapsedSeconds(Math.round((Date.now() - startRef.current) / 1000));
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const filter = qs.stringify(
      {
        populate: {
          diagram: {
            fields: ['id'],
          },
          aglomerations: {
            populate: {
              questions: {
                populate: {
                  responses: {
                    populate: ['variable'],
                    sort: ['order:asc'],
                  },
                },
                fields: ['title', 'order', 'mediaUrl', 'mediaType'],
                sort: ['order:asc'],
              },
            },
            fields: ['id'],
          },
          questions: {
            populate: {
              responses: {
                populate: ['variable'],
                sort: ['order:asc'],
              },
            },
            fields: ['title', 'order', 'mediaUrl', 'mediaType', 'timer'],
            sort: ['order:asc'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      }
    );

    const loadTest = async () => {
      try {
        const testData = await getTest(testId, filter);
        if (!isMounted) return;

        if (!testData) {
          setOpenBlock(true);
          return;
        }

        setOpenBlock(testData?.attributes?.isDesabled || testData?.attributes?.isArchived);
        updateMetaTags(testData);
        await initializeProgress(testData);
      } catch {
        if (isMounted) {
          setOpenBlock(true);
        }
      }
    };

    loadTest();

    return () => {
      isMounted = false;
      if (protectedTag) updateMetaTags(protectedTag);
    };
  }, []);

  useEffect(() => {
    setDataToPost({
      users_permissions_users: [`${user.id}`],
      responses: valueArray,
      test: test?.id,
    });
  }, [valueArray, test?.id, user.id]);

  useEffect(() => {
    if (!testId || !test?.attributes || !progressReady.current) return;

    const persist = {
      valueArray,
      indexArray: currentIndex,
      questionNumber: currentIndex + 1,
      captureEmail,
      emailCaptured,
      showEmailCapture,
      totalQuestions,
      testTitle: test.attributes.title || '',
    };

    if (!isConnected) {
      try {
        localStorage.setItem(progressKey, JSON.stringify(persist));
      } catch {
        alert.openSimpleAlert('Impossible de récupérer le test en cours');
      }
      return;
    }

    const filledResponses = valueArray.filter(
      value => value !== undefined && value !== null && value !== ''
    );
    if (filledResponses.length === 0) return;

    if (draftSaveTimer.current) clearTimeout(draftSaveTimer.current);
    draftSaveTimer.current = setTimeout(() => {
      saveResponseUserProgress({
        testId,
        responses: filledResponses,
        timePassed: Math.round((Date.now() - startRef.current) / 1000),
        state: 'started',
      }).catch(() => undefined);
    }, 500);

    return () => {
      if (draftSaveTimer.current) clearTimeout(draftSaveTimer.current);
    };
  }, [valueArray, currentIndex, captureEmail, emailCaptured, showEmailCapture]);

  const updateMetaTags = (testData: any) => {
    try {
      const tags: any = document.getElementsByTagName('meta');

      if (!protectedTag) {
        setProtectedTag({
          attributes: {
            title: document.title,
            image: tags[5]?.content,
            description: tags.description?.content,
          },
        });
      }

      if (testData?.attributes?.title) document.title = testData.attributes.title;
      if (tags.description && testData?.attributes?.description) {
        tags.description.content = testData.attributes.description;
      }
      if (tags[5] && testData?.attributes?.image) tags[5].content = testData.attributes.image;
      if (tags[4] && testData?.attributes?.image) tags[4].content = testData.attributes.image;
    } catch {
      // Meta tags are non-critical for taking the test.
    }
  };

  const initializeProgress = async (testData: any) => {
    const questionCount = testData?.attributes?.questions?.data?.length || 0;

    if (isConnected) {
      try {
        const record = await getMyResponseUserForTest(testId);
        if (record?.state === 'over') {
          await restartTest(testData);
          return;
        }

        if (record?.state === 'started') {
          const draftResponses: any[] = (record.responses || []).map(
            (response: any) => `${response.id}`
          );
          const nextIndex = Math.min(draftResponses.length, Math.max(questionCount - 1, 0));

          if (draftResponses.length > 0) {
            setSavedProgress({
              valueArray: draftResponses,
              indexArray: nextIndex,
              questionNumber: nextIndex + 1,
              totalQuestions: questionCount,
              testTitle: testData.attributes?.title || '',
              fromBackend: true,
            });
            setShowResumeModal(true);
            setProgress(0, questionCount);
            return;
          }
        }
      } catch {
        alert.openSimpleAlert('Impossible de récupérer le test en cours');
      }

      progressReady.current = true;
      setProgress(0, questionCount);
      return;
    }

    try {
      const saved = localStorage.getItem(progressKey);
      if (saved) {
        const progress = JSON.parse(saved);
        if (progress.indexArray > 0 || progress.valueArray?.length > 0) {
          setSavedProgress(progress);
          setShowResumeModal(true);
          setProgress(0, questionCount);
          return;
        }
      }
    } catch {
      alert.openSimpleAlert('Impossible de récupérer le test en cours');
    }

    progressReady.current = true;
    setProgress(0, questionCount);
  };

  const scrollToTop = () => {
    setTimeout(() => {
      topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const goToQuestion = (index: number) => {
    const safeIndex = Math.max(0, Math.min(index, Math.max(totalQuestions - 1, 0)));
    setCurrentIndex(safeIndex);
    setProgress(safeIndex, totalQuestions);
    Object.values(videoRefs.current).forEach(videoRef => videoRef?.pauseVideo());
    scrollToTop();
  };

  const selectResponse = (responseId: string | number) => {
    const nextValues = [...valueArray];
    nextValues[currentIndex] = responseId;
    setValueArray(nextValues);
  };

  const mapDataCalcul = async (array: any[]) => {
    const searchParams = qs.stringify(
      {
        filters: {
          id: {
            $in: array,
          },
        },
      },
      {
        encodeValuesOnly: true,
      }
    );

    const data: any = await getResponsesPopulate(searchParams);
    const flattenedData = data.data.data.flatMap((item: any) =>
      item.attributes.variable.data.map((variable: any) => ({
        variableKey: variable.attributes.variableKey,
        variableValue: item.attributes.variableValue,
      }))
    );
    const dataGroupByVariableKey = groupBy(flattenedData, 'variableKey');
    const dataMapValue = map(dataGroupByVariableKey, (responsesByVariable: any, key: string) => ({
      somme: sumBy(responsesByVariable, 'variableValue'),
      key,
    }));

    return {
      ...dataToPost,
      variableA: find(dataMapValue, ['key', 'A'])?.somme || 0,
      variableB: find(dataMapValue, ['key', 'B'])?.somme || 0,
      timePassed: Math.round((Date.now() - startRef.current) / 1000),
    };
  };

  const postDataAfterCalculSum = async () => {
    const newDataToPost = await mapDataCalcul(dataToPost.responses);

    if (isConnected) {
      return saveResponseUserProgress({
        testId: test.id,
        responses: newDataToPost.responses,
        timePassed: newDataToPost.timePassed,
        state: 'over',
      });
    }

    return postResponseUsers(newDataToPost);
  };

  const stopTimer = () => {
    const seconds = Math.round((Date.now() - startRef.current) / 1000);
    setElapsedSeconds(seconds);
    dispatch(timeCounterAction.setTimeCount(seconds));
    return seconds;
  };

  const handleEmailContinue = () => {
    if (!captureEmail || !EMAIL_REGEX.test(captureEmail)) return;

    apiServiceNative
      .post('/api/leads', { data: { email: captureEmail, test: testId } })
      .catch(() => undefined);
    setEmailCaptured(true);
    setShowEmailCapture(false);
    goToQuestion(currentIndex + 1);
  };

  const handleNext = async (allowEmpty = false) => {
    if (!allowEmpty && !currentValue) return;

    if (!user.id && currentIndex === 1 && !showEmailCapture && !emailCaptured) {
      setShowEmailCapture(true);
      return;
    }

    if (currentIndex + 1 === totalQuestions) {
      setLoading(true);
      stopTimer();

      if (dataToPost.responses.length === 0) {
        setLoading(false);
        history.push(`/no-response?redirect=test/${testId}/passer/${title}`);
        return;
      }

      if (me) {
        await userService.modifyUser({
          token,
          counterTest: me.counterTest ? parseInt(me?.counterTest, 10) + 1 : 1,
          id: user?.id,
        });
      }

      const postedResponse = await postDataAfterCalculSum();
      localStorage.removeItem(progressKey);

      if (!user.id) {
        setShowSignup(true);
        setLoading(false);
        return;
      }

      history.push(`/congrats/${postedResponse.id}`);
      setLoading(false);
      return;
    }

    goToQuestion(currentIndex + 1);
  };

  const handlePrevious = () => {
    if (showEmailCapture) {
      setShowEmailCapture(false);
      return;
    }

    goToQuestion(currentIndex - 1);
  };

  const handleResumeTest = () => {
    if (!savedProgress) return;

    const nextIndex = savedProgress.indexArray || 0;
    if (savedProgress.valueArray?.length) setValueArray(savedProgress.valueArray);
    if (savedProgress.captureEmail) setCaptureEmail(savedProgress.captureEmail);
    if (savedProgress.emailCaptured) setEmailCaptured(true);
    if (savedProgress.showEmailCapture) setShowEmailCapture(true);
    setCurrentIndex(nextIndex);
    setProgress(nextIndex, totalQuestions);
    progressReady.current = true;
    setShowResumeModal(false);
    setSavedProgress(null);
  };

  const restartTest = async (testData = test) => {
    localStorage.removeItem(progressKey);

    if (isConnected) {
      try {
        await saveResponseUserProgress({
          testId,
          responses: [],
          timePassed: 0,
          state: 'started',
        });
      } catch {
        alert.openSimpleAlert('Erreur lors de la sauvegarde du test en cours');
      }
    }

    setValueArray([]);
    setCurrentIndex(0);
    setCaptureEmail('');
    setEmailCaptured(false);
    setShowEmailCapture(false);
    setShowResumeModal(false);
    setSavedProgress(null);
    startRef.current = Date.now();
    setElapsedSeconds(0);
    setProgress(0, testData?.attributes?.questions?.data?.length || 0);
    progressReady.current = true;
  };

  const navigateAway = (path: string) => {
    if (protectedTag) updateMetaTags(protectedTag);
    history.push(path);
  };

  const handleQuitTest = () => {
    navigateAway('/user/tests');
  };

  const handleGoHome = () => {
    navigateAway(isConnected ? '/main' : '/');
  };

  const renderQuestionMedia = () => {
    const mediaUrl = currentQuestion?.attributes?.mediaUrl;
    if (!mediaUrl) return null;

    return (
      <div className={classes.questionMedia}>
        {currentQuestion.attributes.mediaType === 'image' ? (
          <RedesignImage
            priority={true}
            src={mediaUrl}
            alt="Question"
            className={classes.mediaImage}
          />
        ) : (
          currentQuestion.attributes.mediaType === 'video' && (
            <MediaVideoPlayer
              ref={ref => {
                if (ref) videoRefs.current[currentQuestion.id] = ref;
              }}
              videoUrl={mediaUrl}
            />
          )
        )}
      </div>
    );
  };

  const renderTextResponses = () => (
    <div className={classes.responses}>
      {currentResponses.map((response: any) => {
        const isSelected = parseInt(currentValue, 10) === parseInt(response.id, 10);

        return (
          <button
            key={response.id}
            type="button"
            className={classNames(classes.responseButton, { selected: isSelected })}
            onClick={() => selectResponse(response.id)}>
            <span className={classes.radio} aria-hidden="true" />
            <span className={classes.responseText}>{parseHtml(response.attributes.title)}</span>
          </button>
        );
      })}
    </div>
  );

  const renderImageResponses = () => (
    <div className={classes.imageGrid}>
      {currentResponses.map((response: any) => {
        const isSelected = parseInt(currentValue, 10) === parseInt(response.id, 10);

        return (
          <button
            key={response.id}
            type="button"
            className={classNames(classes.imageOption, { selected: isSelected })}
            onClick={() => selectResponse(response.id)}
            aria-label={`Réponse ${response.id}`}>
            <RedesignImage
              priority={true}
              src={response.attributes.image}
              alt={`Réponse ${response.id}`}
              className={classes.imageOptionImg}
            />
            <span className={classes.imageRadio} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );

  const questionTimer =
    currentQuestion?.attributes?.timer || test?.attributes?.globalTimer || 0;

  const renderTimer = () => {
    if (test?.attributes?.useGlobalTimer) {
      return (
        <span className={classes.timerChip}>
          <AccessTimeIcon className={classes.timerIcon} />
          <QuestionCountdown
            key={currentIndex}
            seconds={questionTimer}
            onEnd={() => handleNext(true)}
            className={classes.timerValue}
          />
        </span>
      );
    }

    return (
      <span className={classes.timerChip}>
        <AccessTimeIcon className={classes.timerIcon} />
        <span className={classes.timerValue}>{formatElapsed(elapsedSeconds)}</span>
      </span>
    );
  };

  const renderHeader = () => (
    <header className={classes.header}>
      <button type="button" className={classes.logoButton} onClick={handleGoHome}>
        <RedesignImage
          priority={true}
          src={`${publicLogoPath}/e-orientaction-redesign.png`}
          alt="E-Orientaction"
          className={classes.logo}
        />
      </button>
      <div className={classes.progressWrap} aria-label={`Progression ${progressPercent}%`}>
        <div className={classes.progressTrack}>
          <div className={classes.progressBar} style={{ width: `${progressPercent}%` }} />
        </div>
        <p className={classes.progressText}>{progressPercent}%</p>
      </div>
      <div className={classes.headerActions}>
        <div className={classes.phoneBlock}>
          <div className={classes.phoneLine}>
            <PhoneIcon fontSize="small" />
            <span>02 43 72 25 88*</span>
          </div>
          <p className={classes.phoneNote}>*Numéro national non surtaxé</p>
        </div>
        <Button
          className={classNames(classes.button, classes.primaryButton)}
          startIcon={<MailOutlineIcon />}
          onClick={() => {
            window.location.href = 'mailto:contact@orientaction.com';
          }}>
          Nous contacter
        </Button>
      </div>
    </header>
  );

  if (loadPage || loading || (!test?.attributes && !openBlock)) {
    return (
      <RedesignThemeProvider>
        <div className={classes.page}>
          {renderHeader()}
          <div className={classes.loadingCenter}>
            <CircularProgress />
            {loading && (
              <Typography className={classes.loadingText}>
                Chargement de vos résultats en cours
              </Typography>
            )}
          </div>
        </div>
      </RedesignThemeProvider>
    );
  }

  if (openBlock) {
    return (
      <RedesignThemeProvider>
        <div className={classes.page}>
          {renderHeader()}
          <main className={classes.main}>
            <div className={classes.unavailable}>
              <Typography className={classes.unavailableTitle}>
                Nous sommes désolés mais ce test n&apos;est plus disponible
              </Typography>
              <Button
                className={classNames(classes.button, classes.primaryButton)}
                onClick={handleGoHome}>
                Aller vers E-ORIENTACTION
              </Button>
            </div>
          </main>
        </div>
      </RedesignThemeProvider>
    );
  }

  const hasImageResponses = currentResponses.some((response: any) => response.attributes.image);

  return (
    <RedesignThemeProvider>
      <div className={classes.page}>
      {renderHeader()}
      <main className={classes.main}>
        <div ref={topRef} />
        {!showSignup && !showEmailCapture && (
          <div className={classes.topActions}>
            <Button
              className={classes.button}
              startIcon={<ExitToAppIcon />}
              onClick={handleQuitTest}>
              Quitter le test
            </Button>
            {renderTimer()}
          </div>
        )}

        {showEmailCapture ? (
          <div className={classes.emailCaptureCard}>
            <div className={classes.emailLayout}>
              <RedesignImage
                priority={true}
                src="/images/MinorTest/test-share.png"
                alt="Test partagé"
                className={classes.emailImage}
              />
              <div>
                <Typography className={classes.emailTitle}>Avant de continuer</Typography>
                <Typography className={classes.emailDescription}>
                  Merci de renseigner votre email, cela permettra en cas de problème technique de ne
                  pas perdre vos résultats.
                </Typography>
                <Typography className={classes.emailLabel}>Email</Typography>
                <TextField
                  variant="outlined"
                  fullWidth={true}
                  size="small"
                  type="email"
                  value={captureEmail}
                  onChange={event => setCaptureEmail(event.target.value)}
                  placeholder="Votre adresse email"
                  onKeyDown={event => {
                    if (event.key === 'Enter') handleEmailContinue();
                  }}
                  InputProps={{
                    className: classes.emailInput,
                    endAdornment: (
                      <InputAdornment position="end">
                        <RedesignImage
                          priority={true}
                          src={`${publicIconPath}/Email.svg`}
                          alt="Email"
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  className={classes.emailButton}
                  onClick={handleEmailContinue}
                  disabled={!captureEmail || !EMAIL_REGEX.test(captureEmail)}>
                  Continuer le test
                </Button>
              </div>
            </div>
          </div>
        ) : showSignup ? (
          <InlineSignup
            testImage={test?.attributes?.image}
            responses={dataToPost}
            defaultEmail={captureEmail}
            testId={testId}
          />
        ) : (
          <section className={classes.contentCard}>
            <div className={classes.questionLayout}>
              <div>
                <Typography component="h1" className={classes.questionTitle}>
                  Question {currentIndex + 1}
                </Typography>
                <div
                  className={classes.questionText}
                  dangerouslySetInnerHTML={{ __html: currentQuestion?.attributes?.title || '' }}
                />
                {renderQuestionMedia()}
              </div>

              <div>{hasImageResponses ? renderImageResponses() : renderTextResponses()}</div>
            </div>

            <div className={classes.footerNav}>
              <Button
                className={classes.button}
                startIcon={<ArrowBackIcon />}
                onClick={handlePrevious}
                disabled={currentIndex === 0}>
                Question précédente
              </Button>
              <Button
                className={classNames(classes.button, classes.primaryButton)}
                endIcon={<ArrowForwardIcon />}
                onClick={() => handleNext()}
                disabled={!currentValue}>
                {nextText}
              </Button>
            </div>
          </section>
        )}
      </main>

      <ResumeTestModal
        open={showResumeModal && Boolean(savedProgress)}
        testTitle={savedProgress?.testTitle || test?.attributes?.title || 'Test'}
        questionNumber={savedProgress?.questionNumber || 1}
        totalQuestions={savedProgress?.totalQuestions}
        onClose={() => restartTest()}
        onResume={handleResumeTest}
        onRestart={() => restartTest()}
      />
      </div>
    </RedesignThemeProvider>
  );
};

export default MinorTestPass;
